export default __webpack_public_path__ + "static/media/expl_08_DE.7405f1e3.png";